/**
 * The live Verizon Home Device Protect offer SKU — `ProductSku.VerizonHomeDeviceProtectAccountLevel`
 * ('3002') in ASP/product-config (partner `verizon`; the static fios `VZN_VHDP` is a different SKU).
 *
 * VHDP is the Long Form AI pilot offer: the narrative container only replaces the offer checklist
 * when this product is the selected offer. The enum itself lives in the sales-domain repo and isn't
 * importable here, so the SKU is pinned as a literal.
 */
export const VHDP_PRODUCT_SKU = "3002";

/**
 * V0 (false, shipping) loads the Contentful fallback itself; V1 (true) waits for a producer narrative
 * and offers a reveal button. Flip when Data Science and Logic Builder start emitting.
 *
 * Not a feature flag: `Sales-isLongFormAiEnabled` is already a per-`employeeId` allowlist, so exposure
 * is gated. Shipping V1 switched off decouples "merged" from "on" — merging it live would open every
 * enabled expert into a pending state nothing resolves. While false the reveal button and the
 * `trigger: "expert"` FallbackShown variant are unreachable.
 */
export const WAIT_FOR_PRODUCER_NARRATIVE = false;

/**
 * Employees who get V1 before the global flip, for testing it against real producer events in
 * nonprod. Exposure still needs `Sales-isLongFormAiEnabled`, so this cannot widen who sees LFA at all,
 * only which mode an already-enabled expert gets. Empty this once `WAIT_FOR_PRODUCER_NARRATIVE` flips.
 */
const PRODUCER_NARRATIVE_EARLY_ACCESS_EMPLOYEE_IDS: ReadonlySet<string> = new Set([
    "353403", // mason.embry
]);

export const shouldWaitForProducerNarrative = (employeeId: string): boolean =>
    WAIT_FOR_PRODUCER_NARRATIVE || PRODUCER_NARRATIVE_EARLY_ACCESS_EMPLOYEE_IDS.has(employeeId);
